import { OrderByPipe } from "./OrderByPipe";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RefUrlPipe } from "./ref-url.pipe";
import { SelectFilterComponent } from "./select-filter/select-filter.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { ErrorStatusCodeTemplateComponent } from "./error-status-code-template/error-status-code-template.component";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatButtonModule } from "@angular/material/button";
import { ValidationReportTableComponent } from "./validation-report-table/validation-report-table.component";
import { MatTableModule } from "@angular/material/table";
import { MatIconModule } from "@angular/material/icon";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatToolbar } from "@angular/material/toolbar";
import { ValidationHeaderComponent } from "./validation-header/validation-header.component";
import { MatDivider } from "@angular/material/divider";
import { ValidationReportSummaryComponent } from "./validation-report-summary/validation-report-summary.component";
import { ValidationHistoryTableComponent } from "./validation-history-table/validation-history-table.component";
import { MatSortModule } from "@angular/material/sort";
import { BreadcrumbComponent } from "./breadcrumb/breadcrumb.component";
import { RouterModule } from "@angular/router";
import { OverlayModule } from "@angular/cdk/overlay";
import { CustomDatepickerWithDisplayedTzComponent } from "./custom-datepicker-with-displayed-tz/custom-datepicker-with-displayed-tz.component";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { TimezoneSelectComponent } from "./timezone-select/timezone-select.component";
import { MatSelectModule } from "@angular/material/select";
import { DateTzPipe } from "./pipes/date-tz.pipe";
import { MetadataBlockComponent } from "./metadata-block/metadata-block.component";
import { MatExpansionModule } from "@angular/material/expansion";
import { DataproviderNamePipe } from "./pipes/dataprovider-name.pipe";
import { MatListModule } from "@angular/material/list";
import { FileUploadModule } from "ng2-file-upload";
import { AppMaterialModule } from "src/app/app.material.module";
import { FormatBytesPipe } from "./pipes/format-bytes.pipe";
import { DefaultFormComponent } from "./default-form/default-form.component";
import { InputTextUppercaseDirective } from "./directives/input-text-uppercase.directive";
import { MapChartsComponent } from "./map-charts/map-charts.component";

@NgModule({
  declarations: [
    OrderByPipe,
    RefUrlPipe,
    SelectFilterComponent,
    ErrorStatusCodeTemplateComponent,
    BreadcrumbComponent,
    ValidationReportTableComponent,
    ValidationHeaderComponent,
    ValidationReportSummaryComponent,
    ValidationHistoryTableComponent,
    CustomDatepickerWithDisplayedTzComponent,
    TimezoneSelectComponent,
    MetadataBlockComponent,
    DateTzPipe,
    FormatBytesPipe,
    DataproviderNamePipe,
    DefaultFormComponent,
    InputTextUppercaseDirective,
    MapChartsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FileUploadModule,
    RouterModule,
    OverlayModule,
    AppMaterialModule,
  ],
  exports: [
    OrderByPipe,
    RefUrlPipe,
    SelectFilterComponent,
    BreadcrumbComponent,
    ValidationReportTableComponent,
    CustomDatepickerWithDisplayedTzComponent,
    TimezoneSelectComponent,
    DateTzPipe,
    FormatBytesPipe,
    DataproviderNamePipe,
    ValidationHeaderComponent,
    ValidationReportSummaryComponent,
    ValidationHistoryTableComponent,
    MetadataBlockComponent,
    DefaultFormComponent,
    InputTextUppercaseDirective,
    MapChartsComponent
  ],
})
export class SharedModule {}
